import type { CollapseProps } from "antd";

import BannerMobileInfo from "./Info";
import BannerDetail from "./BannerMobileDetail";
import BannerMobileFiles from "./BannerMobileFiles";

type BannerMobileItemsProps = {
	hasNavigation?: boolean;
	onHasNavigationChange: (checked: boolean) => void;
	isUpper?: boolean;
    onIsUpperChange?: (checked: boolean) => void;
};

export const BannerDetailConstants = {
	EN: "Banner Detayları - İngilizce",
	TR: "Banner Detayları"
};

export const BannerConstants = {
	INFO: "Banner Özellikleri",
	BANNER_LOCALIZABLE: BannerDetailConstants,
	BANNER_FILES: "Banner Resimleri",
};

export const getBannerMobileItems = ({
	hasNavigation,
	onHasNavigationChange,
	isUpper,
	onIsUpperChange
}: BannerMobileItemsProps): CollapseProps["items"] => [
	{
		key: "1",
		label: BannerConstants.INFO,
		children: <BannerMobileInfo hasNavigation={hasNavigation} onHasNavigationChange={onHasNavigationChange} isUpper={isUpper} onUpperChange={onIsUpperChange} />,
	},
	{
		key: "2",
		label: BannerConstants.BANNER_FILES,
		children: <BannerMobileFiles isUpper={isUpper} />,
	},
	{
		key: "3",
		label: BannerConstants.BANNER_LOCALIZABLE.TR,
		children: <BannerDetail Culture="tr-TR" hasNavigation={hasNavigation} />,
	},
	{
		key: "4",
		label: BannerConstants.BANNER_LOCALIZABLE.EN,
		children: <BannerDetail Culture="en-US" hasNavigation={hasNavigation} />,
	}
];
